import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@hyperhedral/ui";
import { supabase } from "../../lib/supabase";

export function ResetPassword() {
  const [ready, setReady] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    // The client completes the recovery callback before resolving getUser.
    void supabase.auth.getUser().then(({ data, error }) => {
      if (!active) return;
      if (error || !data.user) setError("This reset link has expired or is no longer valid. Request a new link from the sign-in page.");
      else setReady(true);
    }).catch(() => { if (active) setError("We couldn't check your reset link. Please refresh and try again."); });
    return () => { active = false; };
  }, []);
  async function submit(event: React.FormEvent) {
    event.preventDefault();
    if (busy || !ready) return;
    if (password.length < 8) { setError("Use at least 8 characters."); return; }
    if (password !== confirmation) { setError("Your passwords do not match."); return; }
    setBusy(true); setError("");
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      setPassword(""); setConfirmation(""); setDone(true);
    } catch (error) { setError(error instanceof Error ? error.message : "We couldn't save your password. Please try again."); }
    finally { setBusy(false); }
  }
  return <main className="account-page px-6 py-16">
    <div className="account-card mx-auto max-w-md">
      <h1 className="font-display text-3xl text-forest-950">{done ? "Your password is updated." : "Choose a new password."}</h1>
      {error && <p role="alert" className="mt-5 rounded-lg bg-red-50 p-4 text-sm text-red-800">{error}</p>}
      {done ? <p className="mt-5"><Link className="text-forest-700 underline" to="/portal/dashboard">Continue to your account</Link></p>
        : ready ? <form onSubmit={submit} className="mt-6 space-y-5">
          <Input label="New password" type="password" autoComplete="new-password" minLength={8} required value={password} onChange={e => setPassword(e.target.value)} />
          <Input label="Confirm new password" type="password" autoComplete="new-password" minLength={8} required value={confirmation} onChange={e => setConfirmation(e.target.value)} />
          <p className="text-sm text-bark-600">Use at least 8 characters.</p>
          <button disabled={busy} className="w-full rounded-lg bg-forest-800 px-5 py-3 font-semibold text-white disabled:opacity-50">{busy ? "Saving…" : "Save new password"}</button>
        </form> : !error && <p className="mt-5">Checking your reset link…</p>}
      {!done && <Link className="mt-6 block text-sm text-forest-700 underline" to="/portal/login">Back to sign in</Link>}
    </div>
  </main>;
}
